"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _WalletsLayout = _interopRequireDefault(require("./WalletsLayout"));
var _selectors = require("../../redux/margin/selectors");
var _actions = require("../../redux/margin/actions");
var _positionActions = require("../../redux/actions/positionActions");
var _futuresSelectors = require("../../redux/futures/selectors/futuresSelectors");
var _actions2 = require("../../redux/futures/actions");
var _selectors2 = require("../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
    selectedAccountId = _state$user.selectedAccountId,
    AccountId = _state$user.userInfo.AccountId,
    marginAccount = state.margin.accountInfo;
  var isMarginSelected = selectedAccountId === marginAccount.AccountId;
  var spotAccountId = isMarginSelected ? AccountId : selectedAccountId;
  var futuresAccountId = (0, _selectors2.futuresAccountIdSelector)(state);
  return {
    isMarginEnabled: (0, _selectors.isMarginEnabledSelector)(state),
    isMarginSelected: isMarginSelected,
    marginAccountId: marginAccount === null || marginAccount === void 0 ? void 0 : marginAccount.AccountId,
    futuresAccountId: futuresAccountId,
    spotAccountId: spotAccountId,
    isFuturesSelected: (0, _futuresSelectors.isFuturesActiveSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountMarginBalances: function getAccountMarginBalances(accountId) {
      return dispatch((0, _actions.getAccountMarginBalances)(accountId));
    },
    getAccountBalances: function getAccountBalances(accountId) {
      return dispatch((0, _positionActions.getAccountPositions)(accountId));
    },
    getAccountFuturesBalances: function getAccountFuturesBalances(accountId) {
      return dispatch((0, _actions2.getAccountFuturesBalances)(accountId));
    },
    getMarginProductsConfig: function getMarginProductsConfig() {
      return dispatch((0, _actions.getMarginProductsConfig)());
    },
    getFuturesProducts: function getFuturesProducts() {
      return dispatch((0, _actions2.getFuturesProducts)());
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WalletsLayout["default"]);